// extracted by mini-css-extract-plugin
export default {"universalInputArea":"UniversalInputNumber_universalInputArea__sR9rC","input":"UniversalInputNumber_input__Md5o1","red":"UniversalInputNumber_red__vYZdA"};